import { render, staticRenderFns } from "./add.vue?vue&type=template&id=c6f3e7d0"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6f3e7d0')) {
      api.createRecord('c6f3e7d0', component.options)
    } else {
      api.reload('c6f3e7d0', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=c6f3e7d0", function () {
      api.rerender('c6f3e7d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/customerCSG/add.vue"
export default component.exports